export default __webpack_public_path__ + "locales/sq-AL/PaymentsEnterprise.json?hash=5f12aab2e83ccc253ed11892ae78cfa6";